import axios from 'axios';
import { apiHelper } from '@/helpers/index';
let suggestionServiceSingleton;

const suggestionServiceFactory = function() {
  function SuggestionService() {
    suggestionServiceSingleton = this;
  }

  /**
   * This function search for suggestions in API
   * These suggestions help us to construct typeahead input properties
   */
  SuggestionService.prototype.getSuggestions = async function(filter) {
    const url = apiHelper.buildURL('/ui/associations/suggest');
    const response = await axios.post(url, { filter });
    return response.data;
  };

  return suggestionServiceSingleton ? suggestionServiceSingleton : new SuggestionService();
};

suggestionServiceFactory();

export { suggestionServiceSingleton as suggestionService };
